import Button from '../../../components/common/button';
import type { HighlightModalProps } from '../../../features/modals/highlight-modal/types';
import ModalLayout from '../../../features/modals/modal-layout';

const HighlightModal = ({
  closeModal,
  description,
  title,
  data: { onAdd },
}: HighlightModalProps): JSX.Element => {
  const createHighLight = () => {
    const COLORS = [
      'rgba(254, 219, 0, 0.2)',
      'rgba(145, 205, 250, 0.2)',
      'rgba(231, 153, 222, 0.2)',
    ];

    onAdd(COLORS[0]);

    closeModal && closeModal();
  };
  return (
    <ModalLayout closeModal={closeModal} title={title}>
      <div className={'text-sm'}>{description}</div>
      <Button onClick={createHighLight}></Button>
    </ModalLayout>
  );
};

export default HighlightModal;
